import { z } from 'zod';

const VALID_CATEGORIES = ['Food', 'Transport', 'Shopping', 'Fun', 'Health', 'Housing', 'Bills/Other', 'Utilities'] as const;
const VALID_CURRENCIES = ['EUR', 'USD', 'GBP', 'UAH', 'BRL', 'JPY', 'CHF', 'CAD', 'AUD', 'CNY'] as const;

export const expenseSchema = z.object({
  amount: z.number()
    .positive({ message: "Amount must be positive" })
    .max(1000000, { message: "Amount too large" })
    .finite({ message: "Amount must be a valid number" }),
  merchant: z.string()
    .trim()
    .min(1, { message: "Merchant name required" })
    .max(200, { message: "Merchant name too long" }),
  category: z.enum(VALID_CATEGORIES, { 
    errorMap: () => ({ message: "Invalid category" }) 
  }),
  note: z.string()
    .max(500, { message: "Note too long" })
    .optional()
    .nullable(),
  expense_date: z.string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, { message: "Invalid date format" }),
  currency: z.enum(VALID_CURRENCIES, {
    errorMap: () => ({ message: "Invalid currency" })
  }),
  tag: z.string()
    .max(20, { message: "Tag too long (max 20 characters)" })
    .optional()
    .nullable(),
});

export type ValidatedExpense = z.infer<typeof expenseSchema>;
